import { render } from "./PageNotFound.vue?vue&type=template&id=60eb0d5f"
const script = {}

import exportComponent from "/var/www/dating-services.top/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__